/** Vendor-agnostic labels for the live dashboard (Opta / SportRadar / Genius). */

export function liveFeedSource(block, fixture) {
  const fromBlock = String(
    block?.feed_source ||
      block?.live_feed?.live_feed_source ||
      block?.live_feed?.source ||
      ''
  )
    .trim()
    .toLowerCase();
  if (fromBlock) return fromBlock;
  // No block row yet (pre-kickoff, or the feed has never written one): fall back to the
  // fixture. American football is split by league — NCAAF on SportRadar, the NFL on Genius —
  // so the league decides, and only an unrecognised football league falls back to the older
  // of the two.
  const league = String(fixture?.league || '')
    .trim()
    .toLowerCase();
  const sport = String(fixture?.sport || '')
    .trim()
    .toLowerCase();
  if (league === 'nfl') return 'genius';
  if (league === 'ncaaf') return 'sportradar';
  if (
    sport === 'football' ||
    sport === 'ncaaf' ||
    sport === 'nfl' ||
    sport === 'cfb' ||
    sport.includes('football')
  ) {
    return sport === 'nfl' ? 'genius' : 'sportradar';
  }
  return 'opta';
}

export function liveFeedLabel(source) {
  const s = String(source || '')
    .trim()
    .toLowerCase();
  if (s === 'sportradar') return 'SportRadar';
  if (s === 'genius') return 'Genius';
  if (!s || s === 'opta') return 'Opta';
  return s;
}

export function liveVendorId(fixture, block) {
  const src = liveFeedSource(block, fixture);
  if (src === 'sportradar') {
    return String(fixture?.sportradar_game_id || block?.match_opta_id || '').trim();
  }
  if (src === 'genius') {
    // An NFL fixture carries both football vendor ids, so this must be explicit rather than
    // falling through to opta_id and landing on match_opta_id by luck.
    return String(fixture?.genius_fixture_id || block?.match_opta_id || '').trim();
  }
  return String(fixture?.opta_id || block?.match_opta_id || '').trim();
}

/** What the shared second-latch column means for each feed. */
export function secondLatchLabel(source) {
  const s = String(source || '')
    .trim()
    .toLowerCase();
  if (s === 'sportradar') return 'Offence close';
  if (s === 'genius') return 'Risk live';
  return 'Danger zone (x>80)';
}
